import { render } from "./MainSlider.vue?vue&type=template&id=12da302f&scoped=true"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"

import "./MainSlider.vue?vue&type=style&index=0&id=12da302f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12da302f"]])

export default __exports__